import { saveUserInfo, saveUserOwnInfo } from './admin';
import {
  activationKey, authenticationCheck, getIdPortenToken, getStoredToken, idPorten
} from './authentication';
import { info, warn } from '../notify';
import { fillProfileIn, updateUserInfo } from '../user';
import { moveTo } from '../wizard';

const wizard = document.getElementById('wizard');

const removeParameterFromUrl = (p) => {
  const cleared = new URLSearchParams(window.location.search);
  cleared.delete(p);
  // Remove query parameters from URL without refreshing the page
  // window.location.search = ''; // not desirable, it also refreshes
  window.history.replaceState({}, document.title, `?${cleared.toString()}`);
};

const setUserName = (name) => {
  document.getElementById('loggedInUserName').innerHTML = name;
  document.getElementById('logoutBtn').title = `Logg ut (${name})`;
  document.getElementById('profileBtn').title = `Min side (${name})`;
};

export const getUserInfo = () => new Promise((resolve, reject) => {
  console.log('Get user information');
  const api = '/klimagasskalkulator_ws/user';
  getIdPortenToken().then(token => {
    const request = new Request(api, {
      method: 'GET',
      headers: new Headers({ nibiotoken: token })
    });
    idPorten(
      request,
      response => {
        const name = (response.name || response.email);
        info(`Logget inn som «${name}»`);
        setUserName(name);
        if (response.isAdmin) {
          wizard.classList.add('superuser');
          document.getElementById('agv').innerHTML = response.adminGroup || '';
        }
        if (response.userActivated) {
          sessionStorage.removeItem(activationKey);
          removeParameterFromUrl(activationKey);
        }
        fillProfileIn(response);
        resolve(response);
      },
      () => reject(console.log('onError'))
      // () => console.log('onComplete')
    );
  }).catch(err => reject(console.log('catch', err)));
});

const succeed = (msg) => {
  info(msg);
  sessionStorage.removeItem(activationKey);
  removeParameterFromUrl(activationKey);
  moveTo('home');
  authenticationCheck(); // to load user information we did not get before
};

const activateUser = (otp) => {
  console.log('Activate user');
  const api = '/klimagasskalkulator_ws/user';
  const email = document.getElementById('fMail').value;
  const name = document.getElementById('fName').value;
  getIdPortenToken().then(token => {
    const request = new Request(api, {
      method: 'POST',
      body: JSON.stringify({ email, name, otp }),
      headers: new Headers({
        'Content-Type': 'application/json',
        nibiotoken: token
      })
    });
    if (getStoredToken().user) { // Registered, but not activated
      idPorten(request,
        r => succeed('Brukeren ble aktivert'),
        r => warn('Brukeren ble ikke aktivert')
      );
    } else { // not registered yet, try now
      idPorten(request,
        response => {
          succeed('Brukeren ble registrert og aktivert');
          setUserName(response.name);
        },
        () => warn('Brukeren ble verken registrert eller aktivert')
      );
    }
  }).catch(() => {
    warn('Brukeren ble ikke aktivert, må logge seg inn først')
    console.log('No activation, token is not available');
    // login({ target: document.getElementById('loginBtn') });
  });
};

export const submitUserInfo = (e) => {
  console.log('Submit user information', e.submitter.id);
  // Prevent action attribute to be triggered by submit:
  e.preventDefault();

  const form = e.target;
  document.getElementById('fError').hidden = true;
  const email = form.elements.namedItem('mail').value;
  const name = form.elements.namedItem('name').value;
  const eField = form.elements.namedItem('expiration');
  const expiration = eField.value || eField.defaultValue; // value can be empty
  const comment = form.elements.namedItem('comment').value;
  const otp = form.elements.namedItem('otp').value;

  if (wizard.classList.contains('activation')) activateUser(otp);
  else if (wizard.classList.contains('profile')) saveUserOwnInfo(email);
  else if (form.elements.namedItem('mail').disabled) updateUserInfo();
  else saveUserInfo(email, expiration, comment);
};
